import Treatment from '../treatment';

/**
 * Create the action
 */

const { thunk, request, success, error } = Treatment.update(
    (id, data, fetch) => {
        if (data.markAsFinished === true) {
            return fetch.post(`/treatments/mark-as-finished/${id}`);
        }
    }
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
